import { render, staticRenderFns } from "./AdminLayout.vue?vue&type=template&id=68d30d66&scoped=true&"
import script from "./AdminLayout.vue?vue&type=script&lang=ts&"
export * from "./AdminLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AdminLayout.vue?vue&type=style&index=0&id=68d30d66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d30d66",
  null
  
)

export default component.exports